var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config_list != "" || _vm.calendarList != ""
    ? _c(
        "div",
        { staticClass: "livetip-wrapper" },
        [
          _vm.calendarList == ""
            ? _c("div", { staticClass: "configs-div" })
            : _vm.calendarList.length == 1
            ? _c("div", { staticClass: "jiaqun" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-container" }, [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.calendarList, function(i) {
                      return _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          on: {
                            click: function($event) {
                              return _vm.go_zhibo(i)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "left-div" }, [
                            _c("p", { staticClass: "time" }, [
                              _vm._v(
                                _vm._s(_vm.getTime(Number(i.start_time) * 1000))
                              )
                            ]),
                            _vm._v(" "),
                            Number(i.start_time) - 3600 >
                            new Date().getTime() / 1000
                              ? _c("p", { staticClass: "tagtip" }, [
                                  _vm._v("未开始")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            Number(i.start_time) - 3600 <
                              new Date().getTime() / 1000 &&
                            Number(i.start_time) > new Date().getTime() / 1000
                              ? _c("p", { staticClass: "tag" }, [
                                  _vm._v("即将开始")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !i.noLivePush &&
                            Number(i.start_time) <
                              new Date().getTime() / 1000 &&
                            new Date().getTime() / 1000 <
                              Number(i.end_time) + 9000
                              ? _c("p", { staticClass: "tag" }, [
                                  _vm._v("直播中")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            i.noLivePush && i.offline_code
                              ? _c("p", { staticClass: "tagtip" }, [
                                  _vm._v("看回放")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            i.noLivePush && i.offline_code == ""
                              ? _c("p", { staticClass: "tagtip" }, [
                                  _vm._v("已结束")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right-div" }, [
                            _c("p", { staticClass: "lesson-name" }, [
                              _vm._v(_vm._s(i.lesson_name))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "package-name" }, [
                              _vm._v(_vm._s(i.package_name))
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            : _c("div", { staticClass: "jiaqun" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "single_live" },
                  _vm._l(_vm.calendarList, function(i) {
                    return _c(
                      "div",
                      {
                        staticClass: "swiper-slide single_div",
                        on: {
                          click: function($event) {
                            return _vm.go_zhibo(i)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "left-div" }, [
                          _c("p", { staticClass: "time" }, [
                            _vm._v(
                              _vm._s(_vm.getTime(Number(i.start_time) * 1000))
                            )
                          ]),
                          _vm._v(" "),
                          Number(i.start_time) - 3600 >
                          new Date().getTime() / 1000
                            ? _c("p", { staticClass: "tagtip" }, [
                                _vm._v("未开始")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          Number(i.start_time) - 3600 <
                            new Date().getTime() / 1000 &&
                          Number(i.start_time) > new Date().getTime() / 1000
                            ? _c("p", { staticClass: "tag" }, [
                                _vm._v("即将开始")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !i.noLivePush &&
                          Number(i.start_time) < new Date().getTime() / 1000 &&
                          new Date().getTime() / 1000 <
                            Number(i.end_time) + 9000
                            ? _c("p", { staticClass: "tag" }, [
                                _vm._v("直播中")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          i.noLivePush && i.offline_code
                            ? _c("p", { staticClass: "tagtip" }, [
                                _vm._v("看回放")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          i.noLivePush && i.offline_code == ""
                            ? _c("p", { staticClass: "tagtip" }, [
                                _vm._v("已结束")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-div" }, [
                          _c("p", { staticClass: "lesson-name" }, [
                            _vm._v(_vm._s(i.lesson_name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "package-name" }, [
                            _vm._v(_vm._s(i.package_name))
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]),
          _vm._v(" "),
          _vm.zujian_flag
            ? _c("div", { staticClass: "class_dialog" }, [
                _c("div", { staticClass: "dialog_box" }, [
                  _c("div", { staticClass: "dialog_message" }, [
                    _vm._v("手机浏览器暂不支持查看该课件"),
                    _c("br"),
                    _vm._v('你可在"' + _vm._s(_vm.appname) + 'APP"进行查看')
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { on: { click: _vm.cancel_flag } }, [
                      _vm._v("取消")
                    ]),
                    _vm._v(" "),
                    _vm.android
                      ? _c("span", { staticClass: "goapp" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.scheme +
                                  "?type=1&sso_id=" +
                                  _vm.sso_id +
                                  "&orderSn=" +
                                  _vm.sn +
                                  "&spuID=" +
                                  _vm.goodsId +
                                  "&owner=" +
                                  this.$route.query.owner +
                                  "&channel=" +
                                  this.$route.query.channel +
                                  "&orgn=" +
                                  this.$route.query.orgn
                              },
                              on: { click: _vm.search_flag }
                            },
                            [_vm._v("打开APP")]
                          )
                        ])
                      : _vm.ios
                      ? _c(
                          "span",
                          {
                            staticClass: "goapp",
                            on: { click: _vm.search_flag }
                          },
                          [_vm._v("去APP查看")]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.applets_flag && _vm.ios
            ? _c("popup", {
                staticClass: "popop_content",
                attrs: { type: 1 },
                on: { isopen: _vm.popup }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.applets_flag && _vm.android
            ? _c("popup", {
                staticClass: "popop_content",
                attrs: { type: 2 },
                on: { isopen: _vm.popup }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "today_live" }, [
      _vm._v("今日直播"),
      _c("img", {
        staticClass: "play",
        attrs: { src: require("../../../static/images/play.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "today_live" }, [
      _vm._v("今日直播"),
      _c("img", {
        staticClass: "play",
        attrs: { src: require("../../../static/images/play.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b69bbdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b69bbdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/livetip/index.vue
// module id = null
// module chunks = 